<template>
  <a-modal
    v-model="mainVisible"
    class="modal"
    width="1000px"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel(false)"
  >
  <div slot="title" class="tip-icon"> {{title}} </div>
    <div class="message">

      <a-form-model ref="ruleForm" :model="content" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
    
        <a-row>
          <a-col :span="12">
        <a-form-model-item label="用户名" prop="userName" >
          <a-input placeholder="请输入用户名" v-model="content.userName" />
        </a-form-model-item>
      </a-col>
      <a-col :span="12">
        <a-form-model-item label="用户账号" prop="userCode">
          <a-input placeholder="请输入用户账号" v-model="content.userCode" />
        </a-form-model-item>
        </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
        <a-form-model-item label="用户状态" prop="userStatus">
          <a-select v-model="content.userStatus" placeholder="请选择用户状态">
            <a-select-option v-for="item in usrTpList" :key="item.value" :value="item.value">
                {{ item.label }}
             </a-select-option>
          </a-select>
        </a-form-model-item>
   </a-col>
   <a-col :span="12">
        <a-form-model-item label="用户手机号" prop="phoneNo">
          <a-input placeholder="请输入用户手机号" v-model="content.phoneNo" />
        </a-form-model-item>
      </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="部门"  prop="deptId">
            <!-- <a-input placeholder="部门ID" v-model="content.deptId" /> -->
            <a-tree-select
            v-if="deptIddata.length > 0"
              v-model="content.deptId"
              style="width: 100%"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="deptIddata"
              placeholder="请输入部门"
              allow-clear
              tree-default-expand-all
            >
            </a-tree-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="用户类型" prop="userType">
            <a-select v-model="content.userType" placeholder="请选择用户状态">
              <a-select-option v-for="item in userTypeList" :key="item.value" :value="item.value">
                  {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
        <a-form-model-item label="备注" :label-col="{span:3}" :wrapper-col="{span:20}" prop="remark">
          <a-input v-model="content.remark" type="textarea" style="height: 80px;"  placeholder="请输入备注"/>
        </a-form-model-item>
        </a-col>
      </a-row>
      
      <label class="defPwd" v-if="type == 'add'">* 默认密码：{{defPassword}}</label>  
      </a-form-model>
   
  </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button type="primary" class="btaction" @click="handleOk" :loading="disabled"
        >确 定</a-button
      >
    </template>
  </a-modal>
</template>

<script>
import { useradd, userupdate, institutionsLIst ,deptList,userDetail,defaultPwd} from '@/api/api.js'
import { DictionaryService } from '@common/services/dictionary.service'
export default {
  name: 'userAddModal',
  props: ['visible', 'userData', 'type', 'title'],
  data() {
    var checkUserCode = (rule,value,callback) => {
      var reg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g;
      if (reg.test(value)) {
        return callback(new Error("用户账号不能有中文！"));
      }
      if (/\s/g.test(value)) {
        return callback(new Error("用户账号不能有空格！"));
      }
      return true;
    }

    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      treeExpandedKeys: [],
      deptIddata: [],
      usrTpList: [],
      //用户类型数据字典
      userTypeList:[],
      usrSXList:[],
      content: {
        id: "",
        userCode: '',
   
        phoneNo: '',

        userName: '',
        userStatus: undefined,
        userType:undefined,
        remark: '',
        deptId: undefined,
      },
      idlist: [],
      disabled: false,
      rules: {
        userCode: [
          {
            required: true,
            message: '用户账号不能为空！',
            trigger: 'blur',
           
          }, {
            max: 100,
            message: '用户账号长度不能超过100 '
          }, {
            validator: checkUserCode,
            trigger: 'change '
          }
        ],
        userName: [
          {
            required: true,
            message: '用户名不能为空！',
            trigger: 'blur',
          }, {
            max: 100,
            message: '用户名长度不能超过100'
          }
        ],
        phoneNo: [
          {
            required: true,
            message: '请选择用户手机号!',
            trigger: 'blur',
          }, {
            max: 15,
            message: '用户手机号长度不能超过15位'
          },
          {
            min: 11,
            message: '用户手机号长度必须超过11位'
          }

        ],
        userStatus: [
          {
            required: true,
            message: '请选择用户状态',
            trigger: 'change',
          },
        ],
        userType: [
          {
            required: true,
            message: '请选择用户类型',
            trigger: 'change',
          },
        ],
        deptId: [
          {
            required: true,
            message: '请选择部门',
            trigger: 'change',
          }
        ],
        remark: [{
          max: 250,
          message: '备注长度不能超过250'
        }]
      },
      defPassword:"",
      mainVisible:this.visible,
    }
  },
  async created() {

    if (this.type == 'amend') {
      this.content.id = this.userData.id
      userDetail({id:this.content.id}).then((res) => {
        this.content.deptId = res.content.deptId
        this.content.phoneNo = res.content.phoneNo
        this.content.remark = res.content.remark
        this.content.userCode = res.content.userCode
        this.content.userName = res.content.userName
        this.content.userStatus = res.content.userStatus
        this.content.userType = res.content.userType
      })
    }
    if(this.type == 'add'){
      defaultPwd().then((res)=>{
        this.defPassword = res.content;
      }).catch((err) => {
        if (err.message) {
          this.$message.error(err.message);
        } else {
          this.$message.error("网络请求异常");
        }
      });
    }
  },
  computed: {},
  mounted() {

    DictionaryService.getAllNeedDic(["USER_STATUS","USER_TYPE"]).then((res) => {
      this.usrTpList = DictionaryService.getOptions("USER_STATUS");

      this.userTypeList =  DictionaryService.getOptions("USER_TYPE");
      this.deptIdList();
    })
  },
  methods: {
    deptIdList() {

      deptList().then((res) => {
                this.getTreemenu(res.content, 0)
            })
    },
    getTreemenu(data, parentId) {
            var treeMenu = [];
            for (var i = 0; i < data.length; i++) {
                var node = data[i]
              if (data[i].parentId == parentId) {
             
                    var newTree = {
                        key: node.id,
                      title: node.deptName,
                        value:node.id,
                        // mlink:node.deptType,
                        children: this.getTreemenu(data, node.id)
                    };
                    treeMenu.push(newTree)

                }
            }
          
      this.deptIddata = treeMenu
            return treeMenu

        },
    async sectll(val) {
      let parms = {
        pageParam: {
          pageNum: 0,
          pageSize: 0,
          orderBy: '',
        },
        content: {
          orgNm: '',
          organTp: val,
        },
      }
      await institutionsLIst({
        pageParam: parms.pageParam,
        content: parms.content,
      }).then((res) => {
        this.idlist = res.content.rows
      })
    },
    handleOk(e) {
      //弹窗确定
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.disabled = true
          if (this.type == 'add') {
            useradd(this.content).then(
              (res) => {
                if (res.code == '0000') {
                  this.disabled = false
                  this.success('新增成功')
                  this.$emit('close')
                  this.$emit('queryList')
                }
              },
              (err) => {
                this.disabled = false
                this.$message.error('新增失败')
              }
            )
          } else {
            userupdate(this.content).then(
              (res) => {
                if (res.code == '0000') {
                  this.disabled = false
                  this.success('修改成功')
                  this.$emit('close')
                  this.$emit('queryList')
                }
              },
              (err) => {
                this.$message.error('修改失败')
                this.disabled = false
              }
            )
          }
        }
      })
    },
    handleCancel(val) {
      //关闭弹窗
      this.$emit('close',val)
      this.$refs['ruleForm'].resetFields()
    },
    success(title) {
      //提示
      this.$message.success(title, 3)
    },
  },
}
</script>

<style lang="less" scoped="scoped">
.message {
  height: 100%;

  /deep/ .ant-form-item {
    display: flex;
    margin-bottom: 20px !important;
  }
}
.defPwd{
  color: red;
  margin-left: 50px;
}
</style>